export const ResourceType = {
    Category: 1,
    Flashcard: 2,
}